import { render, staticRenderFns } from "./NewInfo.vue?vue&type=template&id=53370812&scoped=true&"
import script from "./NewInfo.vue?vue&type=script&lang=js&"
export * from "./NewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53370812",
  null
  
)

export default component.exports